import React from 'react';
import styles from './index.module.scss';
import TipsImg from '../../../assets/img/tips-img.png';
import getFormatMessage from '../../../locales/get-format-message';

interface IProps {
  readonly openCreateStudioModal: () => void;
  readonly openApplyJoinModal: () => void;
}

export const EmptyStudio = (props: IProps) => {
  const renderForm = () => {
    return (
      <div className={styles.tipsBox}>
        <img src={TipsImg} className={styles.tipsImg} />
        <p className={styles.tipsTitle}>
          {getFormatMessage('no_studio_title')}
        </p>
        <p className={styles.tipsContent}>
          {getFormatMessage('no_studio_content')}
        </p>
      </div>
    );
  };

  const renderCustomSubmitButton = () => {
    return (
      <div className={styles.btnBox}>
        <div onClick={props.openApplyJoinModal} className={styles.applyBtn}>
          {getFormatMessage('apply_to_join_upper')}
        </div>
        <div onClick={props.openCreateStudioModal} className={styles.createBtn}>
          {getFormatMessage('create')}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.formBox}>
      {renderForm()}
      {renderCustomSubmitButton()}
    </div>
  );
};
